// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game_game__kLRP1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  flex-direction: column;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}
.game_inner__vNMd5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.game_rule__HL9gX {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  flex-direction: column;
}
.game_rule-modal__3LSuw {
  max-width: unset !important;
  bottom: 0px !important;
  background-color: white;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
}

.game_modal-container__\\+I1nW {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.game_close-icon__IdkCr {
  margin-bottom: 20px;
  position: absolute;
  top: 16px;
  left: 24px;
}

.game_rule-modal-overlay__XM2JE {
  opacity: 0;
}

.game_modal-list__DFRT6 {
  list-style-type: disc;
  width: 100%;
  overflow: hidden;
  padding-right: 24px;
  padding-left: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #384b70;
  font-size: 14px;
  font-weight: 400;
}

@media screen and (min-width: 1200px) {
  .game_game__kLRP1 {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    flex-direction: column;
  }
  .game_inner__vNMd5 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    width: 100%;
  }
  .game_rule-modal-overlay__XM2JE {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/game/game.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".game {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.rule {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n}\n.rule-modal {\n  max-width: unset !important;\n  bottom: 0px !important;\n  background-color: white;\n  border-top-right-radius: 24px;\n  border-top-left-radius: 24px;\n}\n\n.modal-container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n.close-icon {\n  margin-bottom: 20px;\n  position: absolute;\n  top: 16px;\n  left: 24px;\n}\n\n.rule-modal-overlay {\n  opacity: 0;\n}\n\n.modal-list {\n  list-style-type: disc;\n  width: 100%;\n  overflow: hidden;\n  padding-right: 24px;\n  padding-left: 0px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  color: #384b70;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n@media screen and (min-width: 1200px) {\n  .game {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    min-height: 100vh;\n    flex-direction: column;\n  }\n  .inner {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 1200px;\n    width: 100%;\n  }\n  .rule-modal-overlay {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"game": `game_game__kLRP1`,
	"inner": `game_inner__vNMd5`,
	"rule": `game_rule__HL9gX`,
	"rule-modal": `game_rule-modal__3LSuw`,
	"modal-container": `game_modal-container__+I1nW`,
	"close-icon": `game_close-icon__IdkCr`,
	"rule-modal-overlay": `game_rule-modal-overlay__XM2JE`,
	"modal-list": `game_modal-list__DFRT6`
};
export default ___CSS_LOADER_EXPORT___;
